import React from 'react';
import { Link } from 'react-router-dom';

const openSourceLibraries = [
  // Core / Framework
  { name: 'React', url: 'https://react.dev/', description: 'Library for building user interfaces' },
  { name: 'React Native', url: 'https://reactnative.dev/', description: 'Framework for building native apps with React' },
  { name: 'TypeScript', url: 'https://www.typescriptlang.org/', description: 'Typed JavaScript' },
  // Web
  { name: 'React Router', url: 'https://reactrouter.com/', description: 'Declarative routing for React' },
  // Navigation
  { name: 'React Navigation', url: 'https://reactnavigation.org/', description: 'Routing and navigation for React Native' },
  // UI & animation
  { name: 'React Native Reanimated', url: 'https://docs.swmansion.com/react-native-reanimated/', description: 'Animations and gestures for React Native' },
  { name: 'React Native Gesture Handler', url: 'https://docs.swmansion.com/react-native-gesture-handler/', description: 'Native touch and gesture handling' },
  { name: 'React Native Screens', url: 'https://github.com/software-mansion/react-native-screens', description: 'Native navigation primitives' },
  { name: 'React Native Safe Area Context', url: 'https://github.com/th3rdwave/react-native-safe-area-context', description: 'Safe area insets for notched devices' },
  { name: 'Lottie', url: 'https://airbnb.io/lottie/', description: 'Animation library for After Effects' },
  // Storage & data
  { name: 'Async Storage', url: 'https://github.com/react-native-async-storage/async-storage', description: 'Async key-value storage for React Native' },
  { name: 'Supabase', url: 'https://supabase.com/', description: 'Open source Firebase alternative' },
  // Real-time & communication
  { name: 'LiveKit', url: 'https://livekit.io/', description: 'Real-time audio and video infrastructure' },
  // Firebase
  { name: 'React Native Firebase', url: 'https://rnfirebase.io/', description: 'Firebase SDK for React Native' },
  // Media & docs
  { name: 'React Native WebView', url: 'https://github.com/react-native-webview/react-native-webview', description: 'WebView component for React Native' },
  { name: 'React Native Image Picker', url: 'https://github.com/react-native-image-picker/react-native-image-picker', description: 'Image and video picker' },
  { name: 'React Native FS', url: 'https://github.com/itinance/react-native-fs', description: 'Filesystem access for React Native' },
  // Other
  { name: 'React Native Vector Icons', url: 'https://oblador.github.io/react-native-vector-icons/', description: 'Icon set for React Native' },
  { name: 'React Native ML Kit', url: 'https://developers.google.com/ml-kit', description: 'On-device ML for text recognition' },
  { name: 'UUID', url: 'https://github.com/uuidjs/uuid', description: 'UUID generation' },
  { name: 'Sharp', url: 'https://sharp.pixelplumbing.com/', description: 'High-performance image processing' },
];

const OpenSource: React.FC = () => {
  return (
    <div className="OpenSource-page">
      <h1 className="OpenSource-title">Open Source</h1>
      <p className="OpenSource-intro">
        Monogatari Project builds on the work of the open source community. Our apps—Bye For Now, PerfectPitch, ReadFast, ProgressBar, and FPSEyeTrainer—and this website use the following open source projects:
      </p>
      <ul className="OpenSource-list">
        {openSourceLibraries.map((lib) => (
          <li key={lib.name} className="OpenSource-item">
            <a href={lib.url} target="_blank" rel="noopener noreferrer" className="OpenSource-link">
              {lib.name}
            </a>
            <span className="OpenSource-desc"> — {lib.description}</span>
          </li>
        ))}
      </ul>
      <Link to="/" className="OpenSource-back">← back</Link>
    </div>
  );
};

export default OpenSource;
